module.exports = __webpack_public_path__ + "img/hr-straight-rail-diagonal-left-bottom-ties-remnants.9482cd39.png";